import LawsuitUpdatesRadarChart from "./LawsuitUpdatesRadarChart";

export default LawsuitUpdatesRadarChart;
